export const CUSTOM_TEXT_BLOCK_TYPE = 'CUSTOM_TEXT'
export const CUSTOM_TEXT_BLOCK_TITLE = 'Custom Text'
